import { Routes } from '@angular/router';
import { SettingsMembersPage } from './pages/settings-members-page/settings-members-page';
import { SettingsPage } from './pages/settings-page/settings-page';
import { SettingsGeneralPage } from './pages/settings-general-page/settings-general-page';
import { SettingsAddressPage } from './pages/settings-address-page/settings-address-page';
import { permissionGuard } from '../organizations/guards/permission.guard';

export const SETTINGS_ROUTES: Routes = [
  {
    path: '',
    component: SettingsPage,
    children: [
      {
        path: 'general',
        component: SettingsGeneralPage,
        canActivate: [permissionGuard('ORGANIZATION_MASTERDATA_WRITE')],
      },
      {
        path: 'address',
        component: SettingsAddressPage,
        canActivate: [permissionGuard('ORGANIZATION_MASTERDATA_WRITE')],
      },
      {
        path: 'members',
        component: SettingsMembersPage,
        canActivate: [permissionGuard(['ORGANIZATION_INVITE_USER'])],
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'general',
      },
    ],
  },
];
